<template>
  <button
    type="button"
    data-testid="shop-cart-checkout-btn"
    class="flex h-12 w-full min-w-[160px] items-center justify-center gap-3 rounded-sm bg-primary-main px-4 text-inverse transition-colors hover:bg-primary-strong"
    @click="$emit('checkout')"
  >
    <span class="truncate text-center txt-body-m-bold">{{ t('FestivalShop.cart.proceedToCheckout') }}</span>
    <MdiSvg :path="mdiChevronRight" :size="16" class="shrink-0" />
  </button>
</template>

<script setup lang="ts">
import { mdiChevronRight } from '@mdi/js'
import { MdiSvg } from '@ramp106/omrjs-core-ui'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

defineEmits<{
  checkout: []
}>()
</script>
